export default __webpack_public_path__ + "static/media/8-1_85_185_50A_crop.1c6986d2.jpg";